import React, { useEffect, useState } from 'react'
import CardList from '../utils/cardlist'
import Aimsandscope from '../utils/aimsandscope'
import client from '../../client/Client'
import HeaderBanner from '../ui/HeaderBanner'

interface child {
  children: Content[];
}

interface Content {
  text: string;
}

const PSE = () => {
  const [data, setData] = useState([])
  const [aimsData, setAimsData] = useState<child[]>([])
  const [EDAS, setEDAS] = useState<string>('')

  useEffect(() => {
    client.fetch('*[_type == "PSE"]')
      .then((result) => {
        setData(result[0].PSE_Chairs);
        setAimsData(result[0].AimsandScope);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [])

  useEffect(() => {
    client.fetch('*[_type == "EDAS"]').then((response) => {
      if (response.length > 0) {
        setEDAS(response[0].EDAS);
      }
    })
  }, [])

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-32 pb-24">
      <div className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1" aria-hidden="true">
        <svg width="1360" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>
      
      <HeaderBanner title='PSE' />
      
      <div className="text-left space-y-8 pt-12">
        {/* Welcome Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-800 mb-4">
            Welcome to the International Conference on Power Systems & Smart Energy
          </h1>
          <p className="text-gray-700 leading-relaxed">
            The International Conference on Power Systems & Smart Energy (PSE) is a forum for researchers and specialists in fields related to Power Systems and Smart Energy.
          </p>
        </div>

        {/* PSE Chairs Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-800 mb-6">
            PSE Chairs
          </h1>
          <CardList data={data} />
        </div>

        {/* Aims and Scope Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-800 mb-4">
            Aims and Scope
          </h1>
          <p className="text-gray-700 mb-4 leading-relaxed">
            The International Conference on Power Systems & Smart Energy (PSE) covers the following topics:
          </p>
            <Aimsandscope conference='PSE' aimsAndScope={aimsData} />
          <p className="text-gray-700 mt-4 leading-relaxed">
            SSD-PSE participants will have the possibility to attend all SSD conferences taking place in <b>parallel</b>.
          </p>
        </div>

        {/* Paper Submission Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-800 mb-4">
            Paper Submission
          </h1>
          <div className="space-y-4">
            <p className="text-gray-700 leading-relaxed">
              Papers submitted to SSD-PSE should be written in English and limited to six pages including figures, tables, and references. Paper format and styles are available for download.
            </p>
            <p className="text-gray-700 leading-relaxed">
              All papers will be peer-reviewed on the basis of full manuscripts and acceptance will be based on quality, originality, and relevance. Selected papers at SSD conferences will be offered an opportunity to publish their work (after extension) to some international books and journals.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <a 
                href='https://www.ieee.org/conferences_events/conferences/publishing/templates.html' 
                className='bg-white border-2 border-blue-901 rounded-lg px-6 py-3 shadow-md hover:shadow-lg transition-all duration-300 hover:bg-blue-901 group text-center inline-block'
              >
                <span className='text-blue-901 group-hover:text-white font-semibold'>
                  Access IEEE Template
                </span>
              </a>
            </div>

            {EDAS !== '' && (
              <div className="mt-4 p-4 bg-blue-50 rounded-md border border-blue-200">
                <p className="text-gray-700 leading-relaxed">
                  Paper submission should be done electronically through the{' '}
                  <a href={EDAS} className='text-blue-901 hover:text-blue-800 font-medium underline'>
                    EDAS website
                  </a>. Instructions for using the system for the submission of papers, please have a look either at the Author Instructions or the{' '}
                  <a href="http://edas.info/doc/" className='text-blue-901 hover:text-blue-800 font-medium underline'>
                    EDAS online documentation.
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Additional Information Section */}
        <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-red-600 mb-2">
            Need More Information?
          </h3>
          <p className="text-gray-700">
            For any questions regarding PSE conference, please contact:{' '}
            <a className='text-blue-901 hover:text-blue-800 font-medium underline' href='mailto:info@ssd-multiconf.org'>
              info@ssd-multiconf.org
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default PSE